import { CheckInStep, getStepFromNumber } from "@/constants/checkInSteps";

interface CheckInProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

export function CheckInProgressBar({ currentStep, totalSteps }: CheckInProgressBarProps) {
  const progress = (currentStep / totalSteps) * 100;
  const stepName = getStepFromNumber(currentStep);
  
  // Convert the step enum value to a user-friendly display name
  const getStepDisplayName = (step: CheckInStep | null): string => {
    if (!step) return "";
    
    switch (step) {
      case CheckInStep.TEMPLATE_NAME:
        return "Details & Template";
      case CheckInStep.CHANNEL:
        return "Communication Channel";
      default:
        return "";
    }
  };
  
  const displayName = getStepDisplayName(stepName);
  
  return (
    <div className="w-full max-w-xl mx-auto mb-6">
      <div className="flex justify-between mb-2 text-sm">
        <span className="font-medium">
          Step {currentStep} of {totalSteps}: <span className="text-primary">{displayName}</span>
        </span>
        <span className="text-muted-foreground">{Math.round(progress)}% Complete</span>
      </div>
      <div className="w-full bg-muted h-2 rounded-full overflow-hidden">
        <div 
          className="bg-primary h-full transition-all duration-300 ease-in-out rounded-full"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}